import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyD_MmGZAn4M1_mnXv_avlefH-PVbfkdTQ0',
  authDomain: 'prestige-mesbah.firebaseapp.com',
  databaseURL: 'https://prestige-mesbah-default-rtdb.firebaseio.com',
  projectId: 'prestige-mesbah',
  storageBucket: 'prestige-mesbah.firebasestorage.app',
  messagingSenderId: '71635160340',
  appId: '1:71635160340:web:d591ecc51b208d55640601',
  measurementId: 'G-T4C0MTZFW9',
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
